import React, { useState, useEffect } from 'react';
import Pagination from '@material-ui/lab/Pagination';
import { Helmet } from 'react-helmet-async';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import Spinner from 'react-bootstrap/Spinner';
import Button from 'react-bootstrap/Button';
import * as XLSX from 'xlsx';
import { AfficheClient, SuprimerClient, EnvoyeEmail, AuthClientRequest } from '../../Api/SocieteApi/ClientApi';
import { AjouteClient } from '../../Redux/actions/actionClient';
import { useLocation, useNavigate } from 'react-router-dom';
import { AjouteUrlClient } from '../../Redux/actions/actionUrlClient';
import { useDispatch } from 'react-redux';

import './css/gererClient.css';

const GererClient = () => {
  const [showEmail, setShowEmail] = useState(false);
  const [loadClient, setLoadClient] = useState(false);
  const [dataClient, setDataClient] = useState([]);
  const [clientPaginate, setClientPaginate] = useState([]);
  const [showPaginate, setShowPaginate] = useState(true);
  const [totalPage, setTotalPage] = useState();
  const [page, setPage] = useState(1);


  const [loadEmail, setLoadEmail] = useState(false);
  const [sujet, setSujet] = useState('');
  const [contenu, setContenu] = useState('');

  const [dataClientFilter, setDataClientFilter] = useState([]);
  const [loadValue, setLoadValue] = useState(false);
  const [dataFilter, setDatafilter] = useState([]);

  const [loading, setLoading] = useState(false);

  let location = useLocation();
  let dispatch = useDispatch();
  let navigate = useNavigate();


  useEffect(() => {
    AfficheClientData();
    if (dataClient.length < 10) {
      setShowPaginate(false);
    } else {
      setShowPaginate(true);
    }
  }, [dataClient.length]);



  const AfficheClientData = (value = null) => {
    let dataPage = value === null ? page : value;
    setLoadClient(true);
    AfficheClient(dataPage).then(function (response) {
      console.log('Liste Client =>', response.data.donner);
      setDataClientFilter(response.data.dataClient);
      setDataClient(response.data.clients);
      setClientPaginate(response.data.donner);
      setTotalPage(response.data.totalPage)
    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoadClient(false);
    });
  }

  function formatDate(value) {
    if (value < 10) {
      return "0" + value;
    } else {
      return value;
    }
  }

  const handlePage = (event, value) => {
    setPage(value);
    AfficheClientData(value);
  }

  const handleExportExel = () => {
    let wb = XLSX.utils.book_new(),
      ws = XLSX.utils.json_to_sheet(dataClient);
    XLSX.utils.book_append_sheet(wb, ws, "Lites Clients");
    XLSX.writeFile(wb, "Clients.xlsx");
  }


  const handleSearch = (e) => {
    if (e.target.value !== "") {
      setLoadValue(true);
      let dataFilter = dataClientFilter.filter((resto) => resto.nom.toLowerCase().includes(e.target.value.toLowerCase()) || resto.prenom.toLowerCase().includes(e.target.value.toLowerCase()));
      setDatafilter(dataFilter);
    } else {
      setLoadValue(false);
    }
  }

  const hendleDeleteClient = (idClient) => {
    setLoadClient(true);
    SuprimerClient(idClient).then(function (response) {
      if (response.data.title === "success") {
        AfficheClientData();
        toast.success(response.data?.message);
      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {
      setLoadClient(false);
    });

  }



  const handleEnvoyeEmail = (e) => {
    e.preventDefault();
    setLoadEmail(true);
    const data = { sujet: sujet, contenu: contenu };
    EnvoyeEmail(data).then(function (response) {
      if (response.data.title === "success") {
        toast.success(response.data?.message);
      }
    }).catch(function (error) {
      console.log(error.response);
      toast.warning(error.response.data?.message);
    }).finally(function () {
      setLoadEmail(false);
      setShowEmail(false);
      setSujet('');
      setContenu('');

    });
  }



  const handleAddVisite = (id) => {

    setLoading(true);
    const data = { id: id };
    AuthClientRequest(data).then(function (response) {
      console.log(response);

      dispatch(AjouteUrlClient(location.pathname));
      localStorage.setItem('urlClientSociete', location.pathname);
      localStorage.setItem('client', JSON.stringify(response.data.donner));
      localStorage.setItem('tokenClient', response.data.token);
      dispatch(AjouteClient(response.data.donner));
      if (response.data.title === "success") {
        navigate('/client/donner');
      }

    }).catch(function (error) {
      console.log(error);
      if (error) {
        toast.error(error.response.data?.message);
      }

    }).finally(function () {
      setLoading(false);
    });

  }




  return (
    <div>
      <Helmet>
        <title>Gérer client</title>
        <meta name='description' content='Gérer client' />
        <link rel='canonical' href={location.pathname} />
      </Helmet>
      <div className='container'>
        <div className='gererClient'>
          <h2 className='text-center'>Total Clients {dataClient.length}</h2>
          <div className='header_table'>
            <div className='button_left'>
              {/* <button className='btn'>Trier par :</button> */}
              <input type="text" onChange={handleSearch} placeholder='Recherche restaurant ...' className='form-control' />
            </div>
            <div className='button_right'>
              <button className='btn' onClick={() => setShowEmail(true)}>Envoye email</button>
              <button className='btn' onClick={handleExportExel}>Exporter en exel</button>
            </div>
          </div>
          <div className='table-responsive'>
            {loadClient === true || loading === true ?
              <div className="d-flex justify-content-center mt-2">
                <Spinner animation="border" className="load" variant="info" size="md" />
              </div>
              : <table className='table table-bordered'>
                <thead>
                  <tr>
                    <th>Client</th>
                    <th>Adresse email </th>
                    <th>Téléphone</th>
                    <th>Sexe</th>
                    <th>Mot de passe</th>
                    <th>Visite compte</th>
                    {/* <th>Date d'inscription</th> */}
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>

                  {clientPaginate.length === 0 || dataClientFilter.length === 0 ? <p>Client vide ...</p> :
                    loadValue === true ? dataFilter.length === 0 ? <p>Demande introuvable</p> : dataFilter.map((item, i) => {
                      return (
                        <tr key={i}>
                          <td>{item.nom} {item.prenom}</td>
                          <td>{item.email}</td>
                          <td>{item.telephone}</td>
                          <td>{item.sexe}</td>
                          <td>{item.historiqueAvis}</td>
                          <td><span className='fa fa-address-card' onClick={() => handleAddVisite(item.id)}></span></td>
                          {/* <td>{formatDate(new Date(item.createdAt).getDate()) + "/" + formatDate(parseInt(new Date(item.createdAt).getMonth() + 1)) + "/" + new Date(item.createdAt).getFullYear()}</td> */}
                          <td><span className=' fa fa-trash-o' onClick={() => hendleDeleteClient(item.id)}></span></td>
                        </tr>
                      )
                    }) : clientPaginate.map((item, i) => {
                      return (
                        <tr key={i}>
                          <td>{item.nom} {item.prenom}</td>
                          <td>{item.email}</td>
                          <td>{item.telephone}</td>
                          <td>{item.sexe}</td>
                          <td>{item.historiqueAvis}</td>
                          <td><span className='fa fa-address-card' onClick={() => handleAddVisite(item.id)}></span></td>
                          {/* <td>{formatDate(new Date(item.createdAt).getDate()) + "/" + formatDate(parseInt(new Date(item.createdAt).getMonth() + 1)) + "/" + new Date(item.createdAt).getFullYear()}</td> */}
                          <td><span className=' fa fa-trash-o' onClick={() => hendleDeleteClient(item.id)}></span></td>
                        </tr>
                      )
                    })}
                </tbody>
              </table>}
          </div>
          {showPaginate && <div className='d-flex justify-content-center mt-4'>
            <Pagination
              shape="rounded"
              count={Math.ceil(totalPage)}
              onChange={handlePage}
            />

          </div>
          }
          <p className="version">Version 1</p>
          <Modal
            show={showEmail} onHide={() => setShowEmail(false)}
            size="md"
          >
            <Modal.Body>
              <div className='modal_envoyeEmailClient'>
                <div className='envoyeEmail_header'>
                  <h3>Partager des messages</h3>
                  <span className='fa fa-close' onClick={() => setShowEmail(false)}></span>
                </div>
                <div className='sendEmai_restaurant'>
                  <form onSubmit={handleEnvoyeEmail}>
                    <div className="mb-3">
                      <label htmlFor="exampleFormControlInput1" className="form-label">Sujet</label>
                      <input type="text" className="form-control" value={sujet} onChange={(e) => setSujet(e.target.value)} required id="exampleFormControlInput1" placeholder="Sujet ..." />
                    </div>
                    <div className="mb-3">
                      <label htmlFor="exampleFormControlTextarea1" className="form-label">Contenu</label>
                      <textarea className="form-control" required value={contenu} onChange={(e) => setContenu(e.target.value)} id="exampleFormControlTextarea1" rows={3} placeholder="contentu ..." />
                    </div>
                    <div className='d-flex justify-content-center'>
                      {loadEmail === true ? <Button type="button" className='btn btn_envoyeEmail' disabled>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          variant="info"
                          className="spiner"
                        />
                        Loading...
                      </Button> :

                        <button type="submit" className='btn'>Partager</button>
                      }
                    </div>
                  </form>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>

    </div>
  )
}

export default GererClient